export default function lowestRank (state, getters) {
  return getters.lowestRankedTask ? getters.lowestRankedTask.rank : ''
}
